// What counts as an acceptable password. The sign-up form and the reset form each had their own
// copy of this, which is how the two can drift apart and reject what the other accepted.

import { t } from "../i18n/auth.ts";

/** What a password needs, in the page's language. */
export const passwordRequirement = (): string => t("passwordRule");

export const passwordsDiffer = (): string => t("passwordsDiffer");

export function isValidPassword(password: string): boolean {
    if (password.length < 8) return false;
    if (!/[a-z]/.test(password)) return false;
    if (!/[A-Z]/.test(password)) return false;
    if (!/\d/.test(password)) return false;
    return true;
}

/** The complaint to show, or null when the pair is fine. */
export function passwordProblem(password: string, confirmation: string): string | null {
    if (password !== confirmation) return passwordsDiffer();
    if (!isValidPassword(password)) return passwordRequirement();
    return null;
}
